import { Deserializable } from '../../protocols/deserializable';

export class UpdateSubmissionStatusRequest implements Deserializable {
  public id: number;

  public constructor(id: number) {
    this.id = id;
  }

  public onDeserialize() {}
}
